// ─── Hide/Show Header on Scroll
const siteHeader       = document.querySelector('.site-header');
const hamburger        = document.querySelector('.custom-hamburger');
const SCROLL_THRESHOLD   = 10;
const SCROLLED_THRESHOLD = 100;
let lastScrollY        = window.scrollY;
let ticking            = false;

function updateHeader() {
  const currentScrollY = window.scrollY;
  const menuOpen       = hamburger?.getAttribute('aria-expanded') === 'true';
  const isHidden       = siteHeader.classList.contains('header--hidden');

  // ─── Scrolled state (for background colour etc.)
  if (currentScrollY > SCROLLED_THRESHOLD && !isHidden) {
    siteHeader.classList.add('header--scrolled');
  } else {
    siteHeader.classList.remove('header--scrolled');
  }

  if (!menuOpen) {
    const delta = currentScrollY - lastScrollY;
    if (Math.abs(delta) > SCROLL_THRESHOLD) {
      if (delta > 0 && currentScrollY > siteHeader.offsetHeight) {
        // Scrolling down — hide
        siteHeader.classList.add('header--hidden');
        siteHeader.classList.remove('header--scrolled'); // can't be scrolled if hidden
      } else {
        // Scrolling up — reveal
        siteHeader.classList.remove('header--hidden');
      }
    }
  }

  lastScrollY = currentScrollY;
  ticking     = false;
}

window.addEventListener('scroll', () => {
  if (!ticking) {
    requestAnimationFrame(updateHeader);
    ticking = true;
  }
}, { passive: true });

// ─── Sticky Filter Nav Height
const root = document.documentElement;

function updateNavHeight() {
  const isHidden = siteHeader.classList.contains('header--hidden');
  root.style.setProperty('--nav-height', isHidden ? '0px' : `${siteHeader.offsetHeight}px`);
}

updateNavHeight();
window.addEventListener('resize', updateNavHeight);

const headerObserver = new MutationObserver(updateNavHeight);
headerObserver.observe(siteHeader, { attributeFilter: ['class'] });

siteHeader.addEventListener('transitionend', updateNavHeight);

 
 // Throttle function for better performance
 function throttle(func, limit) {
     let inThrottle;
     return function() {
         const args = arguments;
         const context = this;
         if (!inThrottle) {
             func.apply(context, args);
             inThrottle = true;
             setTimeout(() => inThrottle = false, limit);
         }
     }
 }

 

document.addEventListener('DOMContentLoaded', function() {
     
     // Handle hamburger menu toggle animation
     const hamburgerTogglers = document.querySelectorAll('.custom-hamburger');
     
     hamburgerTogglers.forEach(function(toggler) {
         // Listen for Bootstrap collapse events
         const targetId = toggler.getAttribute('data-bs-target');
         const targetElement = document.querySelector(targetId);
         
         if (targetElement) {
             // When collapse starts to show
             targetElement.addEventListener('show.bs.collapse', function() {
                 toggler.setAttribute('aria-expanded', 'true');
                 toggler.classList.add('active');
                 
             });
             
             // When collapse finishes showing
             targetElement.addEventListener('shown.bs.collapse', function() {
                 toggler.setAttribute('aria-expanded', 'true');
                 // Add menu-active class to body
                  document.body.classList.add('menu-active');
             });
             
             // When collapse starts to hide
             targetElement.addEventListener('hide.bs.collapse', function() {
                 toggler.setAttribute('aria-expanded', 'false');
                 toggler.classList.remove('active');
                
             });
             
             // When collapse finishes hiding
             targetElement.addEventListener('hidden.bs.collapse', function() {
                 toggler.setAttribute('aria-expanded', 'false');
                 // Remove menu-active class from body
                  document.body.classList.remove('menu-active');
             });
         }
         
         // Handle direct click events as fallback
         toggler.addEventListener('click', function() {
             // Toggle aria-expanded attribute
             const isExpanded = toggler.getAttribute('aria-expanded') === 'true';
             toggler.setAttribute('aria-expanded', !isExpanded);
             
             // Toggle active class for additional styling if needed
             toggler.classList.toggle('active', !isExpanded);
             
             // Toggle menu-active class on body as fallback
             document.body.classList.toggle('menu-active', !isExpanded);
         });
     });
     

     // Improve accessibility - announce menu state to screen readers
     hamburgerTogglers.forEach(function(toggler) {
         const updateAriaLabel = function() {
             const isExpanded = toggler.getAttribute('aria-expanded') === 'true';
             const newLabel = isExpanded ? 'Close navigation menu' : 'Open navigation menu';
             toggler.setAttribute('aria-label', newLabel);
         };
         
         // Update on click
         toggler.addEventListener('click', function() {
             setTimeout(updateAriaLabel, 50); // Small delay to ensure aria-expanded is updated
         });
         
         // Initial setup
         updateAriaLabel();
     });
     
 });